export default __webpack_public_path__ + "static/media/invite.6b808a32.svg";